import * as React from "react";
import LazyPicture from "../../../LazyPicture/components/LazyPicture/LazyPicture.js";
/* empty css                         */
const ExclusiveBrandsItem = ({ url, image, mobileImage }) => /* @__PURE__ */ React.createElement("li", { className: "exclusive-brands-item" }, /* @__PURE__ */ React.createElement("a", { className: "exclusive-brands-item__link", href: url }, /* @__PURE__ */ React.createElement(
  LazyPicture,
  {
    className: "exclusive-brands-item__image",
    image,
    mobileImage
  }
)));
const ExclusiveBrandsItem$1 = React.memo(ExclusiveBrandsItem);
export {
  ExclusiveBrandsItem$1 as default
};
//# sourceMappingURL=ExclusiveBrandsItem.js.map
